import React from 'react';
import Circle from '../images/Loader.gif'

const Loader = () => {
    return (
        <div className="load" style={{ height: '100vh', width: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={Circle} alt="load" width={150} />
        </div>
    );
};

export default Loader;
